"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldCondition = void 0;
const condition_1 = require("./condition");
const operator_1 = require("./operator");
class FieldCondition extends condition_1.Condition {
    constructor() {
        super("Field Condition");
    }
    static create(fieldAccessor, value, operatorType, operatorName) {
        let fieldCondition = new FieldCondition();
        fieldCondition.fieldAccessor = fieldAccessor;
        fieldCondition.value = value;
        fieldCondition.operator = operator_1.Operator.getOp(operatorType, operatorName);
        return fieldCondition;
    }
    static createRuleAssistCondition(node) {
        let fieldCondition = new FieldCondition();
        fieldCondition.fieldAccessor = node.accessor;
        let operator = new operator_1.Operator();
        operator.operatorType = node.type;
        fieldCondition.operator = operator;
        return fieldCondition;
    }
}
exports.FieldCondition = FieldCondition;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/casa-rules-v2/field-condition.js
// module id = 1224
// module chunks = 0